import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { IconMenu, IconPerfil, IconSalir } from './icons';

interface Props {
  onAbrirMenu: () => void;
}

export function Topbar({ onAbrirMenu }: Props) {
  const { usuario, user, staffEventoId, cerrarSesion } = useAuth();
  const nombre = usuario?.nombre ?? user?.email ?? '';

  return (
    <header className="sticky top-0 z-20 flex h-14 items-center justify-between border-b border-borde bg-fondo/95 px-4 backdrop-blur sm:px-6">
      <button
        type="button"
        onClick={onAbrirMenu}
        aria-label="Abrir menú"
        className="-ml-1.5 flex h-9 w-9 items-center justify-center rounded-full text-navy transition hover:bg-navy/5 active:scale-[0.98] md:hidden"
      >
        <IconMenu className="h-5 w-5" />
      </button>

      <span className="hidden truncate text-sm font-medium text-texto/70 md:block">{nombre}</span>

      <div className="flex items-center gap-1">
        {!staffEventoId && (
          <Link
            to="/perfil"
            className="flex h-9 w-9 items-center justify-center rounded-full text-navy transition hover:bg-navy/5 active:scale-[0.98]"
            aria-label="Mi perfil"
            title="Mi perfil"
          >
            <IconPerfil className="h-5 w-5" />
          </Link>
        )}
        <button
          type="button"
          onClick={() => void cerrarSesion()}
          className="flex h-9 w-9 items-center justify-center rounded-full text-navy transition hover:bg-navy/5 active:scale-[0.98]"
          aria-label="Cerrar sesión"
          title="Cerrar sesión"
        >
          <IconSalir className="h-5 w-5" />
        </button>
      </div>
    </header>
  );
}
